import React from 'react'
import './StatusBadge.css'

const StatusBadge = ({ status, variant = 'default' }) => {
  const statusClass = `status-badge status-${status?.toLowerCase() || 'default'}`
  
  return (
    <span className={`${statusClass} variant-${variant}`}>
      {status || 'Unknown'}
    </span>
  )
}

export default StatusBadge

